import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=666eb81f&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=js&"
export * from "./CustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=666eb81f&lang=scss&scoped=true&"
import style1 from "./CustomerList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666eb81f",
  null
  
)

export default component.exports